import * as _ from 'lodash'

const proto = {
	set: function (val, current) { // eslint-disable-line consistent-return
		if (this.isValid(val)) {
			return (this._flags) ? ((current || 0) | val) : val;
		}
		else {
			console.warn('invalid flag set for ' + this.name + ': ' + val); // eslint-disable-line no-console
		}
	},
	unset: function (val, current) { // eslint-disable-line consistent-return
		if (this.isValid(val)) {
			return (this._flags) ? ((current || 0) & ~val) : 0;
		}
		else {
			console.warn('invalid flag unset for ' + this.name + ': ' + val); // eslint-disable-line no-console
		}
	},
	isValid: function (val) {
		if (this._flags) {
			return (this._flags & val) === (val || 0);
		}
		else {
			return _.some(this._items, { value: (val || 0) });
		}
	},
	isSet: function (val, current) {
		return (this._flags) ? ((current || 0) & val) === val : current === val;
	},
	getDisplayName: function (val) {
		const names = _.map(_.filter(this._items, x => {
			// be sure that "None", "Unknown", etc. aren't included
			return x.value && this.isSet(x.value, val);
		}), x => {
			return x.displayName || x.name;
		});

		return names.join(', ');
	},
	getName: function (val) {
		const names = _.map(_.filter(this._items, x => {
			return (val === x.value) || (x.value !== 0 && this.isSet(x.value, val));
		}), function (x) {
			return x.name;
		});

		return names.join(', ');
	},
	getItems: function () {
		return this._items;
	},
	getValues: function () {
		return _.map(this._items, function (x) {
			return x.value;
		});
	},
	getNames: function () {
		return _.map(this._items, function (x) {
			return x.name;
		});
	},
	getDisplayNames: function () {
		return _.map(this._items, function (x) {
			return x.displayName || x.name;
		});
	}
};

function factory (name, data) {
	let flags = 0;
	let min = 0;
	let max = 0;

	if (data.isFlags) {
		_.forEach(data.items, function (x) {
			flags |= x.value;
		});
	}
	const result = {};

	_.forEach(data.items, function (x) {
		result[x.name] = x.value;
		if (x.value < min) { min = x.value; }
		if (x.value > max) { max = x.value; }
	});

	return _.assign(result, proto, { name: name, _items: data.items, _flags: flags, min: min, max: max });
}

interface EnumInstance {
	min: number;
	max: number;
	[key: string]: number;
}

interface Enums {
	addressTypes: typeof proto & EnumInstance,
	phoneNumberTypes: typeof proto & EnumInstance,
	jobCostLineItemReportingFlags: typeof proto & EnumInstance,
	contactMethods: typeof proto & EnumInstance,
	contractorTypes: typeof proto & EnumInstance,
	businessSegments: typeof proto & EnumInstance,
	jobSettingGroups: typeof proto & EnumInstance,
	jobCostSettingGroups: typeof proto & EnumInstance,
	jobCostStatGroups: typeof proto & EnumInstance,
	trackableActions: typeof proto & EnumInstance,
	vendorTypes: typeof proto & EnumInstance,
	specGroups: typeof proto & EnumInstance,
	contractorUpgradeTypes: typeof proto & EnumInstance,
	setTypeData: (name: string, data) => void;
}

const defaultExport = {
	setTypeData: function (name, data) {
		this[name] = factory(name, data);
	}
};

export default defaultExport as any as Enums;